import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vShow as _vShow, withDirectives as _withDirectives, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/app/ui/assets/svg/ic_failed_unread.svg'

const _withId = /*#__PURE__*/_withScopeId("data-v-71e332d2")

_pushScopeId("data-v-71e332d2")
const _hoisted_1 = {
  id: "pickup-manifest",
  class: "relative bg-white flex flex-col text-12px xxl:text-14px overflow-hidden h-screen w-full"
}
const _hoisted_2 = { class: "flex flex-col justify-between items-start border-b border-gray-lp-400 z-20 relative px-6" }
const _hoisted_3 = { class: "flex flex-row py-2 align-middle items-center justify-between w-full" }
const _hoisted_4 = { class: "text-20px text-black-lp-200 flex flex-row items-center flex-no-wrap relative" }
const _hoisted_5 = {
  class: "mr-8 font-semibold",
  style: {"align-self":"center"}
}
const _hoisted_6 = { class: "flex gap-x-6 text-16px border-b border-gray-lp-400 pt-3 px-6" }
const _hoisted_7 = {
  key: 0,
  src: _imports_0,
  class: "w-4 h-4 mt-1.5",
  alt: "unread"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_lp_button = _resolveComponent("lp-button")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("div", _hoisted_4, [
          _createVNode("span", _hoisted_5, _toDisplayString(_ctx.getTitle), 1)
        ]),
        (_ctx.ableToCreate)
          ? (_openBlock(), _createBlock(_component_lp_button, {
              key: 0,
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.handlerModalSTTPaid(true))),
              title: _ctx.$t('Booking Kargo'),
              textColor: "white"
            }, null, 8, ["title"]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createVNode("div", null, [
      _createVNode("div", _hoisted_6, [
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.tabs, (tab) => {
          return (_openBlock(), _createBlock("div", {
            key: tab.name,
            class: "flex flex-row"
          }, [
            _createVNode("button", {
              onClick: ($event: any) => (_ctx.changeTabs(tab.name)),
              class: 
              `pb-4 font-semibold hover:text-red-lp-100 focus:outline-none ${
                _ctx.isTabActive(tab.name)
                  ? 'text-red-lp-100 border-b-2 border-red-lp-100'
                  : 'text-gray-lp-600'
              }`
            
            }, _toDisplayString(tab.title), 11, ["onClick"]),
            (tab.name === 'booking-canceled' && _ctx.hasNewCanceledFailed)
              ? (_openBlock(), _createBlock("img", _hoisted_7))
              : _createCommentVNode("", true)
          ]))
        }), 128))
      ])
    ]),
    _createVNode(_component_router_view),
    _withDirectives(_createVNode(_component_Modal, {
      onSubmit: _ctx.goToCreate,
      title: "Pastikan Nomor STT Sudah Terbayar",
      message: "Cek kembali nomor STT Adjusted atau yang kelebihan berat, pastikan sudah terbayar lunas",
      image: "payment/payment-cash-illustration",
      textSuccess: "OK",
      class: "px-8"
    }, null, 8, ["onSubmit"]), [
      [_vShow, _ctx.showModalSTTPaid]
    ])
  ]))
})